import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import useLocalStorageState, { LOCAL_STORAGE_KEYS } from "@/hooks/useLocalStorageState";

export const WorkspaceIntroDialog = () => {
  const [showIntro, setShowIntro] = useLocalStorageState<boolean | null>(
    LOCAL_STORAGE_KEYS.ONBOARDING_WORKSPACE_INTRO_MODAL,
    null,
  );

  return (
    <Dialog open={!!showIntro} onOpenChange={setShowIntro}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">Welcome to PromptLayer!</DialogTitle>
        </DialogHeader>

        <img src="/wrangler_cooking.png" alt="Wrangler cooking" className="w-full" />

        <div className="space-y-4">
          <p className="font-semibold text-gray-600">We're setting up Wrangler AI for you.</p>{" "}
          <p className="text-sm text-gray-600">
            In a few moments, we'll build your prompt, dataset, and eval. Then you can dive into the
            fast, powerful iteration loop you came for.
          </p>
        </div>

        <DialogFooter>
          <Button onClick={() => setShowIntro(null)}>Got it</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
